var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('breadcrumb',{attrs:{"routerList":[{to:'/basic/role',title:'用户管理'},{title:'用户授权'}]}}),_c('userdatagrant')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }